<template>
  <div>
    <div class="d-flex flex-wrap align-items-center">
      <h4 class="mb-0 mr-auto">
        {{ $t('store_list_page.store_list') }}
      </h4>
      <a-button
        v-if="permission.includes('WRITE') && !isDMSOffline"
        icon="plus-square"
        class="add__button"
        size="large"
        @click="$router.push({name: 'add-store', query: {...getQueryParam($route.query)}})"
        @-click="openModalMW()"
      >
        {{ $t('store_list_page.add_store') }}
      </a-button>
    </div>
    <div class="row no-gutters my-3">
      <div class="col-md-4 d-flex align-items-center pr-md-4">
        {{ $t('store_list_page.channel') }}:
        <a-select
          class="flex-grow-1 ml-3 text-capitalize select-antd-default"
          size="large"
          :value="valueChannel"
          @change="onChangeChannel"
        >
          <a-select-option
            v-for="state in list_channel"
            :key="state.sales_channel_id"
            class="text-capitalize"
            :value="state.sales_channel_id"
          >
            {{ state.sales_channel_id === 'all' ? $t('store_list_page.all_channel') : state.name }}
          </a-select-option>
        </a-select>
      </div>
      <div class="col-md-4 d-flex align-items-center">
        {{ $t('store_list_page.store_status') }}:
        <a-select
          class="flex-grow-1 ml-3 text-capitalize select-antd-default"
          size="large"
          :value="valueStatus"
          :filter-option="false"
          @change="onChangeStatus"
        >
          <a-select-option
            v-for="state in list_status"
            :key="state"
            class="text-capitalize"
            :value="state"
          >
            {{ state === 'all' ? $t('store_list_page.all_status') : state }}
          </a-select-option>
        </a-select>
      </div>
      <div class="col-md-4 d-flex align-items-center pl-md-4">
        {{ $t('store_list_page.country') }}:
        <a-select
          class="flex-grow-1 ml-3 select-antd-default"
          size="large"
          :value="valueCountry"
          @change="onChangeCountry"
        >
          <a-select-option
            v-for="country in COUNTRIES"
            :key="country.code"
            :value="country.code"
          >
            {{ country.code === 'all' ? $t('store_list_page.all_country') : country.name }}
          </a-select-option>
        </a-select>
      </div>
    </div>
    <div class="row mx-0">
      <div class="col-md-9 pl-0">
        <a-input-search
          :loading="loadingSearch"
          size="large"
          :placeholder="$t('store_list_page.search_placeholder')"
          :value="valueSearch"
          @change="onChangeSearch"
          @search="onSearch"
        >
          <a-button slot="enterButton" class="btn-search">
            {{ $t('utils.search') }} <a-icon type="search" />
          </a-button>
        </a-input-search>
      </div>
      <div class="col-md-3 pr-0 d-flex align-items-center">
        <div class="flexno pr-3">
          {{ `${$t('order.sortBy')}:` }}
        </div>
        <a-select
          class="w-100 ml-auto text-capitalize select-antd-default"
          size="large"
          :value="sortBy"
          option-filter-prop="children"
          @change="onChangeSort"
        >
          <a-select-option
            v-for="sort in sort_"
            :key="sort.value"
            class="text-capitalize"
            :value="sort.value"
          >
            {{ sort.label }}
          </a-select-option>
        </a-select>
      </div>
    </div>

    <div class="store-table-wrapper mt-3">
      <TableBorder>
        <template #thead>
          <th v-for="th in THEAD" :key="th" scope="col" :style="{ width: th === 'action' ? '125px' : 'auto' }">
            {{ $t('store_list_page.' + th) }}
          </th>
        </template>
        <tbody v-if="data.length">
          <tr v-for="val in data" :key="val.id">
            <td>
              <div class="store-name" @click="onShowDrawerDetail(val)">
                <img
                  :alt="val.title"
                  draggable="false"
                  width="30"
                  height="30"
                  class="mr-2"
                  :style="{ objectFit: 'contain', padding: ['shopee_id','tokopedia_id', 'tiktok', 'tiktok_id', 'blibli_id', 'lazada_id', 'zalora_id', 'accurate_pos', 'toco_id'].includes(val.sales_channel?.code) ? '0' : '5px' }"
                  :src="
                    val?.notes === 'tiktok_tokopedia'
                      ? require(`@/assets/store/${val?.notes}.png`)
                      : ['shopee_id','tokopedia_id', 'tiktok', 'tiktok_id', 'blibli_id', 'lazada_id', 'zalora_id', 'accurate_pos', 'toco_id'].includes(val.sales_channel?.code)
                        ? require(`@/assets/store/${val.sales_channel?.code.toLowerCase()}.png`)
                        : require('@/assets/images/logo_small.png')
                  "
                />
                {{ val.title }}
              </div>
            </td>
            <td>{{ val?.sales_channel?.name || '-' }}</td>
            <td
              v-if="val.status"
              :class="val.status === 'CONNECTED'
                ? 'st-connect'
                : val.status === 'DISCONNECTED' || val.status === 'DISCONNECT' || ['TOKEN_EXPIRED'].includes(val?.status?.toUpperCase())
                  ? 'st-disconnected'
                  : val?.status?.toUpperCase() === 'REAUTHENTICATION_REQUIRED'
                    ? 'st-reauth'
                    : 'st-pending'
              "
            >
              {{
                val.status === 'CONNECTED'
                  ? $t('store_list_page.status_label.connected')
                  : val.status === 'DISCONNECTED' || val.status === 'DISCONNECT'
                    ? $t('store_list_page.status_label.disconnected')
                    : val?.status?.toUpperCase() === 'REAUTHENTICATION_REQUIRED'
                      ? $t('store_list_page.status_label.reauthentication_required')
                      : val?.status?.toUpperCase() === 'TOKEN_EXPIRED'
                        ? $t('store_list_page.status_label.token_expired')
                        : val.status === 'WAITING'
                          ? $t('store_list_page.status_label.waiting')
                          : val.status === 'PENDING_WAREHOUSE'
                            ? $t('store_list_page.status_label.pending_warehouse')
                            : val.status
              }}
            </td>
            <td v-else>
              {{ '-' }}
            </td>
            <td>
              <time>{{
                val.connected_at
                  ? $moment(val.connected_at, 'YYYY-MM-DD HH:mm').format(
                    'DD-MM-YYYY HH:mm',
                  )
                  : '-'
              }}</time>
            </td>
            <!-- <td>
            {{
              val.sales_channel.country_name
                ? val.sales_channel.country_name
                : '-'
            }}
          </td> -->
            <!-- <td>
            <ConsoleLink
              v-if="!val.confirmed"
              :to="{
                name: 'store.product-synchronize',
                params: { id: val.id },
              }"
              class="text-primary font-weight-bold"
            >
              {{ val.notes ? val.notes : '-' }}
            </ConsoleLink>
          </td> -->
            <td class="action-btn" style="text-align: right;">
              <a-dropdown
                v-if="val.status && val.status.toUpperCase() !== 'DISCONNECTED' && 
                  ['shopee_id', 'tokopedia_id', 'tiktok', 'tiktok_id', 'lazada_id', 'zalora_id', 'blibli_id', 'tiktok_tokopedia', 'toco_id'].includes(val.sales_channel.code)"
              >
                <a @click.prevent="">
                  <a-icon type="more" />
                </a>
                <template #overlay>
                  <a-menu>
                    <a-menu-item
                      v-if="permission.includes('WRITE') && 
                        val.sales_channel.code === 'tokopedia_id' && 
                        $store.state.user.role_name?.toLowerCase() === 'super user' &&
                        val?.status?.toUpperCase() === 'WAITING'"
                      key="1"
                      class="py-2"
                      @click="showModal(val)"
                    >
                      {{ $t('store_list_page.actions.approve') }}
                    </a-menu-item>
                    <!-- <a-menu-item
                    v-if="permission.includes('WRITE') && 
                      ['blibli_id'].includes(val.sales_channel.code) && 
                      $route.query.business_id && 
                      val?.status?.toUpperCase() === 'CONNECTED'"
                    key="3"
                    class="py-2"
                    @click="updateStoreStatus(val, val.sales_channel.code)"
                  >
                    <a-icon type="check-circle" class="menu-reconnect" />
                    {{ val?.detail?.auto_accept ? $t('store_list_page.actions.deactivate') : $t('store_list_page.actions.activate') }} {{ $t('store_list_page.auto_accept_order') }}
                  </a-menu-item> -->
                    <a-menu-item
                      v-if="permission.includes('WRITE') && 
                        val.sales_channel.code === 'blibli_id' && 
                        $route.query.business_id && 
                        ['CONNECTED', 'PENDING_WAREHOUSE'].includes(val?.status?.toUpperCase())"
                      key="5"
                      class="py-2"
                      @click="showWarning(val)"
                    >
                      <a-icon type="close-circle" class="menu-disconnect" />
                      {{ $t('store_list_page.actions.disconnect') }}
                    </a-menu-item>
                    <a-menu-item
                      v-if="permission.includes('WRITE') && 
                        ['shopee_id', 'tokopedia_id', 'tiktok', 'tiktok_id', 'lazada_id', 'zalora_id', 'toco_id'].includes(val.sales_channel.code) && 
                        $route.query.business_id && 
                        ['CONNECTED', 'PENDING_WAREHOUSE'].includes(val?.status?.toUpperCase())"
                      key="6"
                      class="py-2 d-flex align-items-center"
                      @click="onPopconfirmDisconnectStore(val.sales_channel.code, val.id)"
                    >
                      <a-icon type="close-circle" class="menu-disconnect" />
                      {{ $t('store_list_page.actions.disconnect') }}
                    </a-menu-item>
                    <a-menu-item
                      v-if="permission.includes('WRITE') && val?.status?.toUpperCase() === 'PENDING_WAREHOUSE'"
                      key="2"
                      class="py-2"
                      @click="openModalAddWarehouse(val)"
                    >
                      <a-icon type="bank" />
                      {{ $t('store_list_page.actions.mapping_warehouse') }}
                    </a-menu-item>
                    <a-menu-item
                      v-if="permission.includes('WRITE') && 
                        ['shopee_id', 'lazada_id', 'tiktok', 'tiktok_id', 'tokopedia_id', 'blibli_id', 'zalora_id', 'toco_id'].includes(val.sales_channel.code) && 
                        $route.query.business_id && 
                        val?.status?.toUpperCase() === 'CONNECTED'"
                      key="7"
                      class="py-2 d-flex align-items-center"
                      @click="dataEditWarehouse = val, showModalEditWarehouse = true"
                    >
                      <a-icon type="bank" />
                      {{ $t('store_list_page.actions.edit_mapping_warehouse') }}
                    </a-menu-item>
                    <a-menu-item
                      v-if="permission.includes('WRITE') && 
                        ['shopee_id', 'tokopedia_id', 'tiktok', 'tiktok_id', 'toco_id'].includes(val.sales_channel.code) && 
                        $route.query.business_id && 
                        val?.status?.toUpperCase() === 'DISCONNECTED'"
                      key="8"
                      class="py-2 d-flex align-items-center"
                      @click="onReconnectChannel(val.sales_channel.code, val.id)"
                    >
                      <a-icon type="check-circle" class="menu-reconnect" />
                      {{ $t('store_list_page.actions.reconnect') }}
                    </a-menu-item>
                    <a-menu-item
                      v-if="permission.includes('WRITE') && 
                        ['shopee_id', 'shopee'].includes(val.sales_channel.code) && 
                        $route.query.business_id && 
                        ['REAUTHENTICATION_REQUIRED', 'TOKEN_EXPIRED'].includes(val?.status?.toUpperCase())"
                      key="9"
                      class="py-2 d-flex align-items-center"
                      @click="onReauthorizeShopee(val)"
                    >
                      <a-icon type="reload" />
                      {{ $t('store_list_page.actions.reauthorize') }}
                    </a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
            </td>
          </tr>
        </tbody>
      </TableBorder>
    </div>

    <LoadingListTable v-if="loadingData" />
    <template v-else>
      <ErrorInfo v-if="errorRows" :error-type="errorRows" />
      <EmptyInfo
        v-else-if="!errorRows && !data.length"
        :title="$t('store_list_page.empty_title')"
        :description="$t('store_list_page.empty_msg')"
      />
    </template>

    <Pagination
      v-if="!loadingData && data.length"
      class="text-right"
      :total="total_row"
      :page-size="pageSize"
      :total-length-per-page="data.length"
      :default-page="defaultPage"
      @changePage="onChangePage"
    />
    <ModalBusiness
      :show-modal-edit="showModalEdit"
      :show-success="showSuccess"
      :show-failed="showFailed"
      :row-data="rowData"
      @handleShowModal="handleShowModal"
      @handleSubmitEdit="handleSubmitEdit"
    />

    <!-- Modal add marketplace or warehouse -->
    <modal-list-marketplace-warehouse
      :visible="modalListMW"
      :open-modal-m-w="openModalMW"
      :open-modal-sync="openModal"
    />
    <modal-approve-confirmation
      :visible="modalApproveConfirmation"
      :open-modal="actionModalApproveConfirmation"
      :selected-data="selectedData"
      @emitSuccessApprove="onSuccessApprove"
    />
    <modal-add-warehouse-channel
      :visible="showModalAddWarehouseChannel"
      :open-modal="actionModalAddWarehouseChannel"
      :selected-data="selectedData"
      @emitSuccessAddWarehouse="onSuccessAddWarehouse"
    />
    <modal-sync
      :visible="modalSync"
      :back="openModalMW"
      :open-modal="openModal"
      :open-modal-success="openModalSuccess"
      :id-data="idData"
    />
    <modal-success-sync
      :visible="modalSuccessSync"
      :back="openModalMW"
      :open-modal-success="openModalSuccess"
    />
    <ModalDisconnectStore
      :visible="showModalDisconnectStore"
      :data="dataDisconnectStore"
      :loading="loadingModalDisconnectStore"
      @handleShowModal="handleShowModalDisconnectStore"
      @handleSubmitModal="onDisconnectChannel"
    />
    <ModalUpdateMappingWarehouseV2
      :visible="showModalEditWarehouse"
      :data="dataEditWarehouse"
      @onCancel="handleShowModalEditWarehouse"
      @onOk="handleSubmitEditWarehouse"
      @onRefreshList="handleRefreshListAfterMapping"
    />
    <a-drawer
      :title="$t('store_list_page.detail.title')"
      placement="right"
      :closable="true"
      :visible="viewDetail"
      width="800"
      @close="onCloseDrawer"
    >
      <div class="d-flex flex-column drawer-container">
        <div class="d-flex">
          <div class="w-50">
            <div class="font-weight-bold">
              {{ $t('store_list_page.store_name') }}
            </div>
            <div>{{ dataDrawerDetail?.title || '-' }}</div>
          </div>
          <!-- <div class="w-50">
            <div class="font-weight-bold">
              Last Product Sync
            </div>
            <div>-</div>
          </div> -->
        </div>
        <div class="d-flex">
          <div class="w-50">
            <div class="font-weight-bold">
              {{ $t('store_list_page.store_status') }}
            </div>
            <div>{{ dataDrawerDetail?.status ?? '-' }}</div>
          </div>
          <!-- <div class="w-50">
            <div class="font-weight-bold">
              Last Order Sync
            </div>
            <div>-</div>
          </div> -->
        </div>
        <div class="d-flex">
          <div class="w-100">
            <div class="font-weight-bold">
              {{ $t('store_list_page.detail.channel_id') }}
            </div>
            <div>{{ dataDrawerDetail?.id || '-' }}</div>
          </div>
        </div>
        <div v-if="!['tiktok', 'tiktok_id', 'blibli_id', 'zalora_id', 'shopee_id', 'distributor', 'toco_id'].includes(dataDrawerDetail?.sales_channel?.code)" class="d-flex">
          <div class="w-100">
            <div class="font-weight-bold">
              {{ $t('store_list_page.auto_accept_order') }}
            </div>
            <div class="mt-1">
              <a-skeleton :loading="loadingWarehouse" :paragraph="{ rows: 0 }" active>
                <a-popconfirm
                  :title="$t('store_list_page.auto_accept.confirm_title', { action: dataDetailChannel.auto_accept ? $t('store_list_page.actions.deactivate') : $t('store_list_page.actions.activate') })"
                  :ok-text="$t('store_list_page.auto_accept.confirm_ok', { action: dataDetailChannel.auto_accept ? $t('store_list_page.actions.deactivate') : $t('store_list_page.actions.activate') })"
                  :cancel-text="$t('store_list_page.actions.cancel')"
                  @confirm.prevent="onChangeAutoAccept('all')"
                >
                  <a-switch size="large" :checked="dataDetailChannel.auto_accept" :loading="fetchingUpdateAutoAccept" />
                </a-popconfirm>
              </a-skeleton>
            </div>
          </div>
        </div>
        <div class="d-flex whs">
          <div class="w-100">
            <div class="d-flex font-weight-bold">
              {{ $t('store_list_page.detail.warehouse') }}
            </div>
            <div v-if="!loadingWarehouse && !warehouseList.length">
              -
            </div>
            <a-skeleton v-else :loading="loadingWarehouse" :paragraph="{ rows: 0 }" active>
              <a-divider class="my-2" />
              <div class="d-flex font-weight-bold" style="font-size: 12px;">
                <div :style="{ width: ['distributor'].includes(dataDrawerDetail?.sales_channel?.code) ? '50%' : '30%' }">
                  {{ $t('store_list_page.detail.warehouse_channel') }}
                </div>
                <div :style="{ width: ['distributor'].includes(dataDrawerDetail?.sales_channel?.code) ? '50%' : '30%' }">
                  {{ $t('store_list_page.detail.warehouse_master') }}
                </div>
                <div v-if="!['distributor'].includes(dataDrawerDetail?.sales_channel?.code)" style="width: 17%">
                  {{ $t('store_list_page.detail.arrange_shipment') }}
                </div>
                <div v-if="['shopee_id', 'tiktok', 'tiktok_id', 'blibli_id', 'zalora_id', 'toco_id'].includes(dataDrawerDetail?.sales_channel?.code)" style="width: 18%">
                  {{ $t('store_list_page.detail.auto_receive') }}
                </div>
                <div v-if="['shopee_id', 'tiktok', 'tiktok_id', 'blibli_id', 'zalora_id', 'toco_id'].includes(dataDrawerDetail?.sales_channel?.code)" style="width: 5%" />
              </div>
              <div v-for="warehouse in warehouseList" :key="warehouse.warehouse_master_id">
                <a-divider class="my-2" />
                <div class="d-flex">
                  <div :style="{ width: ['distributor'].includes(dataDrawerDetail?.sales_channel?.code) ? '50%' : '30%' }">
                    {{ warehouse.warehouse_channel_name }}
                  </div>
                  <div :style="{ width: ['distributor'].includes(dataDrawerDetail?.sales_channel?.code) ? '50%' : '30%' }">
                    {{ warehouse.warehouse_master_name }}
                  </div>
                  <div v-if="!['distributor'].includes(dataDrawerDetail?.sales_channel?.code)" style="width: 17%">
                    {{ warehouse.channel_order_auto_accept_step }}
                  </div>
                  <div v-if="['shopee_id', 'tiktok', 'tiktok_id', 'blibli_id', 'zalora_id', 'toco_id'].includes(dataDrawerDetail?.sales_channel?.code)" style="width: 18%">
                    <a-tag :color="warehouse.auto_accept ? 'blue' : 'red'">
                      {{ warehouse.auto_accept ? $t('store_list_page.active') : $t('store_list_page.inactive') }}
                    </a-tag>
                  </div>
                  <div v-if="['shopee_id', 'tiktok', 'tiktok_id', 'blibli_id', 'zalora_id', 'toco_id'].includes(dataDrawerDetail?.sales_channel?.code)" style="width: 5%" class="text-right">
                    <a-dropdown :trigger="['click']" placement="bottomRight">
                      <a @click.prevent="">
                        <a-icon type="more" />
                      </a>
                      <template #overlay>
                        <a-menu>
                          <a-menu-item
                            @click="showModalAutoAccept = true, formAutoAccept.confirm = true, selectedWarehouseAutoAccept = warehouse, isChangeArrangeShipment = true"
                          >
                            {{ $t('store_list_page.auto_accept.change_arrange_shipment') }}
                          </a-menu-item>
                          <a-menu-item
                            @click="showModalAutoAccept = true, formAutoAccept.confirm = warehouse.auto_accept, selectedWarehouseAutoAccept = warehouse, isChangeAutoAccept = true"
                          >
                            {{ $t('store_list_page.auto_accept.change_auto_accept') }}
                          </a-menu-item>
                        </a-menu>
                      </template>
                    </a-dropdown>
                  </div>
                </div>
                <div v-if="warehouse.updated_at" style="font-size: 10px; color: grey">
                  {{ $t('store_list_page.detail.last_updated') }} <span>{{ $moment(warehouse.updated_at).format('HH:mm:ss, DD-MMM-YYYY') }}</span>
                </div>
              </div>
              <a-divider class="my-2" />
            </a-skeleton>
          </div>
        </div>
        <div v-if="dataDrawerDetail?.sales_channel?.code === 'tokopedia_id' || dataDrawerDetail?.notes === 'tiktok_tokopedia'" class="binding-box">
          <div class="binding-box-image">
            <div>
              <img :src="require('@/assets/store/tokopedia.png')" />
              <img :src="require('@/assets/store/switch-horizontal.png')" />
              <img :src="require('@/assets/store/tiktok-shop.png')" />
            </div>
          </div>
          <div v-if="dataDrawerDetail?.notes === 'tiktok_tokopedia'">
            <h3 class="mb-0">
              {{ $t('store_list_page.detail.binding_done') }}
            </h3>
          </div>
          <div v-else>
            <h3>{{ $t('store_list_page.detail.read_terms') }}</h3>
            <ol>
              <li v-for="n in 7" :key="n">
                {{ $t(`store_list_page.detail.binding_terms.${n}`) }}
              </li>
            </ol>
            <a-checkbox v-model="isAgreeBinding" class="binding-box-checkbox" :disabled="isBinding">
              {{ $t('store_list_page.detail.terms_checkbox') }}
            </a-checkbox>
            <a-button
              class="mt-3"
              type="primary"
              block
              :disabled="!isAgreeBinding || isBinding"
              :loading="isBinding"
              @click="bindTiktok(dataDrawerDetail?.sales_channel?.code, dataDrawerDetail?.id)"
            >
              <a-icon type="disconnect" /> {{ $t('store_list_page.actions.bind_now') }}
            </a-button>
          </div>
        </div>
      </div>
    </a-drawer>
    <a-modal
      :visible="visible"
      :title="$t('store_list_page.integration.approve_title')"
      :closable="false"
      :footer="null"
    >
      <div>
        <ol class="pl-3 text-left">
          <li class="text-desc" style="text-align: justify;">
            {{ $t('store_list_page.integration.desc_1', { storeName: rowData.title }) }}
          </li>
        </ol>
        <div class="mb-3" style="color: #7777FF; font-style: italic">
          {{ $t('store_list_page.integration.desc_path') }}
        </div>
        <ol start="2" class="pl-3 text-left">
          <li class="text-desc" style="text-align: justify;">
            {{ $t('store_list_page.integration.desc_2', { storeName: rowData.title }) }}
          </li>
        </ol>
        <a-input v-model="approval.app_id" class="mb-3" :placeholder="$t('store_list_page.integration.enter_app_id')" />
        <ol start="3" class="pl-3 text-left">
          <li class="text-desc" style="text-align: justify;">
            {{ $t('store_list_page.integration.desc_3', { storeName: rowData.title }) }}
          </li>
        </ol>
        <a-input v-model="approval.shop_id" :placeholder="$t('store_list_page.integration.enter_shop_id')" />
        <div class="mt-5" style="text-align: right">
          <a-button
            class="mr-2"
            :loading="loadingApprove"
            @click="showModal({})"
          >
            {{ $t('store_list_page.actions.cancel') }}
          </a-button>
          <a-button
            type="primary"
            :loading="loadingApprove"
            :disabled="!approval.shop_id || !approval.app_id"
            @click="onApprove"
          >
            {{ $t('store_list_page.actions.agree') }}
          </a-button>
        </div>
      </div>
    </a-modal>

    <a-modal :visible="warningVisible" :width="successDisconnect ? 350 : 450" :closable="false" :footer="null">
      <div class="warning-logo">
        <a-icon v-if="successDisconnect" type="check-circle" theme="twoTone" two-tone-color="#52c41a" />
        <a-icon v-else type="warning" theme="twoTone" two-tone-color="#faad14" />
      </div>
      <div v-if="loadingBlibliData" class="warning-loading">
        <a-skeleton :loading="loadingBlibliData" :paragraph="{ rows: 1, width: '100%' }" active />
      </div>
      <div v-else class="warning-description">
        <p v-if="successDisconnect" class="mb-0" v-html="$t('store_list_page.disconnect_warning.success_msg', { storeName: store.name })" />
        <p v-else class="mb-0" v-html="$t('store_list_page.disconnect_warning.confirm_msg', { storeName: store.name })" />
      </div>
      <div class="warning-button">
        <a-row :gutter="16">
          <a-col :span="successDisconnect ? 24 : 12">
            <a-button
              v-if="successDisconnect"
              type="primary"
              size="large"
              class="w-100"
              :disabled="loadingBlibliData || loadingDisconnect"
              @click="refreshPage"
            >
              {{ $t('store_list_page.actions.confirm') }}
            </a-button>
            <a-button
              v-else
              type="primary"
              size="large"
              class="w-100"
              :disabled="loadingBlibliData || loadingDisconnect"
              @click="warningVisible = false"
            >
              {{ $t('store_list_page.actions.cancel') }}
            </a-button>
          </a-col>
          <a-col :span="12">
            <a-button
              v-if="!successDisconnect"
              type="primary"
              size="large"
              class="w-100"
              ghost
              :loading="loadingBlibliData || loadingDisconnect"
              @click="disconnectStore"
            >
              {{ $t('store_list_page.auto_accept.confirm_ok', { action: '' }).replace(', ', '') }}
            </a-button>
          </a-col>
        </a-row>
      </div>
    </a-modal>
    <a-modal
      :visible="showModalAutoAccept"
      :title="isChangeArrangeShipment ? $t('store_list_page.auto_accept.change_arrange_shipment') : $t('store_list_page.auto_accept.change_auto_accept')"
      :closable="false"
      :ok-text="$t('store_list_page.actions.confirm')"
      @ok="onSubmitFormAutoAccept"
      @cancel="showModalAutoAccept = false, formAutoAccept.shipment = undefined, selectedWarehouseAutoAccept = null, isChangeArrangeShipment = false,isChangeAutoAccept = false"
    >
      <div>
        <a-form-model ref="refFormAutoAccept" :model="formAutoAccept">
          <template v-if="!isChangeArrangeShipment">
            <a-form-model-item prop="confirm" class="mb-1">
              <a-checkbox v-model="formAutoAccept.confirm" size="large" :disabled="!isChangeAutoAccept">
                {{ $t('store_list_page.auto_accept_order') }}
              </a-checkbox>
            </a-form-model-item>
            <a-alert
              type="info"
              show-icon
              style="font-size: 12px;"
              :message="$t('store_list_page.auto_accept.info_message', { channelName: getChannelName })"
            />
          </template>
          <a-form-model-item
            v-if="!!formAutoAccept.confirm"
            prop="shipment"
            :label="$t('store_list_page.auto_accept.update_arrange_shipment')"
            class="mb-1"
            :rules="[{ required: !!formAutoAccept.confirm, message: $t('store_list_page.auto_accept.select_shipment') }]"
          >
            <a-select
              v-model="formAutoAccept.shipment"
              size="large"
              class="w-100 select-antd-default"
              show-search
              allow-clear
              option-filter-prop="children"
              :filter-option="filterOption"
              :placeholder="$t('store_list_page.auto_accept.select_shipment')"
            >
              <a-select-option v-for="item in shipmentList" :key="item.value" :value="item.value">
                <span>{{ item.label }}</span>
                <span class="text-desc">
                  <a-tooltip :title="getShipmentTooltip(item)">
                    <a-icon class="ml-2" type="info-circle" />
                  </a-tooltip>
                </span>
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>

<script>
import LoadingListTable from '@/components/Loading/ListTable'
import EmptyInfo from '@/components/EmptyInfo'
import ErrorInfo from '@/components/ErrorInfo'
import TableBorder from '@/components/Table/TableBorder.vue'
import Pagination from '@/components/Pagination/index.vue'
import ModalBusiness from '@/components/Store/ModalBusiness'
import ModalDisconnectStore from '@/components/Store/ModalDisconnectStore'
import ModalUpdateMappingWarehouseV2 from '@/views/store/ModalUpdateMappingWarehouseV2.vue'
import ModalListMarketplaceWarehouse from '@/components/Store/AddStore/ModalListMarketplaceWarehouse.vue'
import { getLazadaWarehouseChannelList, updateLazadaAutoAcceptOrder } from '@/api/channels/lazada'
import addStore from '@/composable/store/addStore'
import ModalSync from '@/components/Store/AddStore/ModalSync.vue'
import ModalSuccessSync from '@/components/Store/AddStore/ModalSuccessSync.vue'
import getQueryParam from '@/utils/getQueryParam'
import ModalApproveConfirmation from '@/components/Store/AdminStore/ModalApproveConfirmation.vue'
import ModalAddWarehouseChannel from '@/components/Store/AdminStore/ModalAddWarehouseChannel.vue'
import { disconnectChannelWithPause, reconnectChannelWithPause, updateAutoAcceptChannel, getDetailChannel, updateDataDetailChannel } from '@/api/channels/index'
import { getBlibliDataDetail, getBlibliPickupPoint, updateAutoAcceptOrder, disconnectBlibli, updateAutoAcceptPerWarehouseBlibliChannel } from '@/api/channels/blibli'
import { confirmIntegrationTokopedia, getTokopediaDetailChannel } from '@/api/channels/tokopedia'
import debounce from 'lodash/debounce'
import { disconnectTiktokIntegration, getTiktokDetailChannel, updateTiktokAutoAcceptPerWarehouse } from '@/api/channels/tiktok'
import { getShopeeDetailChannel, disconnectShopeeIntegration, updateShopeeAutoAcceptPerWarehouse } from '@/api/channels/shopee'
import { disconnectZalora, getZaloraDetailChannel, updateZaloraAutoAcceptPerWarehouse } from '@/api/channels/zalora'
import { getDistributorAppWarehouses } from '@/api/channels/distributor'
import { getTocoDetailChannel, disconnectTocoIntegration, updateTocoAutoAcceptPerWarehouse } from '@/api/channels/toco'

const SORT_BY = 'alphabetical'
export default {
  name: 'ProductConfirmation',
  components: {
    LoadingListTable,
    EmptyInfo,
    ErrorInfo,
    TableBorder,
    Pagination,
    ModalBusiness,
    ModalListMarketplaceWarehouse,
    ModalSync,
    ModalSuccessSync,
    ModalApproveConfirmation,
    ModalAddWarehouseChannel,
    ModalDisconnectStore,
    ModalUpdateMappingWarehouseV2,
  },
  mixins: [getQueryParam],
  setup(props) {
    const {
      dataMarketPlace,
      dataFulfilment,
      modalSync,
      modalSuccessSync,
      modalListMW,
      openModalMW,
      openModal,
      openModalSuccess,
      idData,
    } = addStore(props)

    return {
      dataMarketPlace,
      dataFulfilment,
      modalSync,
      modalSuccessSync,
      modalListMW,
      openModalMW,
      openModal,
      openModalSuccess,
      idData,
    }
  },
  data() {
    return {
      COUNTRIES: [],
      THEAD: [
        'store_name',
        'sales_channel',
        'store_status',
        'authorization_time',
        'action',
      ],
      hitApi: 0,
      loadingData: true,
      loadingSearch: false,
      loadingBlibliData: false,
      loadingDisconnect: false,
      loadingWarehouse: false,
      valueSearch: '',
      valueChannel: 'all',
      valueStatus: 'Semua Status',
      valueCountry: 'all',
      sortBy: SORT_BY,
      total_row: 20,
      pageSize: 20,
      defaultPage: 1,
      data: [],
      errorRows: false,
      list_channel: [],
      list_status: [],
      showModalEdit: false,
      showSuccess: false,
      showFailed: false,
      rowData: {},
      warehouseList: [],
      viewDetail: false,
      dataDrawerDetail: null,
      modalApproveConfirmation: false,
      selectedData: null,
      showModalAddWarehouseChannel: false,
      visible: false,
      warningVisible: false,
      successDisconnect: false,
      store: {
        business_id: null,
        id: null,
        name: null,
        channel_id: null,
      },
      approval: {
        shop_id: '',
        aggregator_id: '',
        app_id: '',
      },
      loadingApprove: false,
      showModalDisconnectStore: false,
      loadingModalDisconnectStore: false,
      dataDisconnectStore: null,
      showModalEditWarehouse: false,
      dataEditWarehouse: null,
      dataDetailChannel: {},
      mappingStatusRefreshId: 0,
      fetchingUpdateAutoAccept: false,
      isBinding: false,
      isAgreeBinding: false,
      abortController: null,
      formAutoAccept: {
        confirm: false,
        shipment: undefined,
      },
      showModalAutoAccept: false,
      selectedWarehouseAutoAccept: null,
      isChangeArrangeShipment: false,
      isChangeAutoAccept: false,
    }
  },
  computed: {
    isDMSOffline() {
      return this.$store.getters['user/isDMSOffline']
    },
    permission() {
      return this.$store.getters['user/can'](this.$route.meta.key)
    },
    getChannelName() {
      const currentChannelCode = this.dataDrawerDetail?.sales_channel?.code
      if(currentChannelCode === 'tokopedia_id') {
        return 'Tokopedia'
      } else if(currentChannelCode === 'blibli_id') {
        return 'Blibli'
      } else if(currentChannelCode === 'shopee_id') {
        return 'Shopee'
      } else if(currentChannelCode === 'zalora_id') {
        return 'Zalora'
      } else if(currentChannelCode === 'toco_id') {
        return 'Toco'
      } else {
        return this.$t('store_list_page.auto_accept.this_channel')
      }
    },
    sort_() {
      return [
        {
          label: this.$t('store_list_page.auto_accept.sort.alphabetical'),
          value: 'alphabetical',
        },
        {
          label: this.$t('store_list_page.auto_accept.sort.numerical'),
          value: 'numeric',
        },
      ]
    },
    shipmentList() {
      return [
        { 
          value: 'PICK_CONFIRMED', 
          label: this.$t('store_list_page.auto_accept.shipment_label.picking'), 
          tooltip: this.$t('store_list_page.auto_accept.shipment_tooltip.picking'),
        },
        { 
          value: 'SALES_ITEMS_BOOKED', 
          label: this.$t('store_list_page.auto_accept.shipment_label.allocated'), 
          tooltip: this.$t('store_list_page.auto_accept.shipment_tooltip.allocated'),
        },
      ]
    },
  },
  watch: {
    '$route.query'() {
      this.onRequest()
    },
    warningVisible(isVisible) {
      if(!isVisible) {
        this.successDisconnect = false
        this.store = {
          business_id: null,
          id: null,
          name: null,
          channel_id: null,
        }
      }
    },
    viewDetail(value) {
      if (!value) this.isAgreeBinding = false
    },
  },
  mounted() {
    this.onRequest()
    this.checkReauthorizeCallback()
  },
  beforeDestroy() {
    this.mappingStatusRefreshId += 1
  },
  methods: {
    checkReauthorizeCallback() {
      const local = JSON.parse(localStorage.getItem('pathCallback'))
      if (local && local.query && local.query.is_reauthorize && local.query.name === 'shopee') {
        if (this.$route.query.code) {
          this.$store.dispatch('integration/REAUTHORIZESHOPEECONFIRM', {
            client_id: local.query.client_id,
            business: local.query.business_id || this.$route.query.business_id,
            shop_id: this.$route.query.shop_id,
            code: this.$route.query.code,
            main_account_id: local.query.main_account_id,
          }).then(({ data }) => {
            if (data?.code != null && !['200', '201'].includes(data?.code)) {
              this.$notification.error({
                message: this.$t('store_list_page.messages.reauthorize_failed_title'),
                description: data?.message,
              })
            } else {
              this.$notification.success({
                message: this.$t('store_list_page.messages.reauthorize_success_title'),
                description: this.$t('store_list_page.messages.reauthorize_success_desc'),
              })
            }
          }).catch(err => {
            this.$notification.error({
              message: this.$t('store_list_page.messages.reauthorize_failed_title'),
              description: err.response?.data?.message || err.message,
            })
          }).finally(() => {
            localStorage.removeItem('pathCallback')
            const query = { ...this.$route.query }
            delete query.code
            delete query.shop_id
            delete query.is_reauthorize
            delete query.name
            this.$router.replace({ query })
            this.onRequest()
          })
        }
      }
    },
    async _fetchAllWarehouses(params) {
      let currentPage = 1
      let totalPages = 1
      const allData = []
      do {
        const { page, total_pages, data } = await this.$store.dispatch('warehouse/GETSALESWAREHOUSE', {
          ...params,
          page: currentPage,
          size: 20,
        })
        allData.push(...data.map(obj => ({ ...obj, value: obj.id, label: obj.name, checked: true })))
        totalPages = total_pages
        currentPage = page + 1
      } while (currentPage <= totalPages)
      return allData
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().includes(input.toLowerCase())
    },
    getShipmentTooltip(item) {
      try {
        const channel = this.getChannelName
        return (item && item.tooltip)
          ? item.tooltip.replace('{channel}', channel)
          : ''
      } catch (e) {
        return (item && item.tooltip) || ''
      }
    },
    onCloseDrawer() {
      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
      }
      this.viewDetail = false
      this.dataDetailChannel = {}
    },
    async bindTiktok(channelCode, channelId) {
      if (channelId && channelCode === 'tokopedia_id') {
        this.isBinding = true
        const route = {
          path: '/add-store',
          query: {
            ...this.$route.query,
            'company-aggregator-id': 123,
            name: 'tiktok',
          },
        }
        localStorage.setItem('pathCallback', JSON.stringify(route))
        localStorage.setItem('channelId', channelId)
        localStorage.setItem('needBinding', true)
        const { data } = await this.$store.dispatch('integration/SYNCTIKTOK', 123)
        window.location = data.data.authorized_url
      }
    },
    async onApprove() {
      this.loadingApprove = true
      try {
        await confirmIntegrationTokopedia({
          id: this.rowData.id,
          business_id: this.$route.query.business_id,
          data: { ...this.approval },
        })
      } catch (err) {
        if (err) this.$message.error(this.$t('store_list_page.auto_accept.error_save_inventory'), 5)
        throw err
      } finally {
        this.loadingApprove = false
        this.showModal({})
        this.onRequest()
      }
    },
    async showWarning(row) {
      this.loadingBlibliData = true
      this.warningVisible = true
      await getBlibliDataDetail({
        business_id: this.$route.query.business_id,
        channel_id: row?.id,
      })
      .then(({ data: { data: response } }) => {
        this.store = {
          business_id: response?.business_id,
          id: response?.store_id,
          name: response?.store_name,
          channel_id: response?.channel_id,
        }
      })
      .catch(err => {
        console.error(err)
        this.store = {
          business_id: null,
          id: null,
          name: null,
          channel_id: null,
        }
      })
      .finally(() => this.loadingBlibliData = false)
    },
    async updateStoreStatus(value, channelCode) {
      if (['blibli_id'].includes(channelCode)) {
        await updateAutoAcceptOrder({
          business_id: value?.detail?.business_id || this.$route.query.business_id,
          data: {
            store_id: value?.detail?.store_id || '',
            channel_id: value?.detail?.channel_id || 0,
            auto_accept: !value?.detail?.auto_accept,
          },
        })
        .then(({ data }) => {
          const isSuccess = data.status.toLowerCase() === 'failed'
            ? false : true
          const notificationType = isSuccess ? 'success' : 'error'
          const notificationMessage = isSuccess ? this.$t('store_list_page.auto_accept.status_success') : this.$t('store_list_page.auto_accept.status_failed')
          const notificationDescription = value?.detail?.auto_accept
            ? this.$t('store_list_page.auto_accept.deactivate') : this.$t('store_list_page.auto_accept.activate')
          this.$notification[notificationType]({
            message: data?.code || `${this.$t('store_list_page.auto_accept.change_auto_accept')} ${notificationMessage}`,
            description: data?.message || 
              `${this.$t('store_list_page.auto_accept_order')} ${value?.title || value?.sales_channel?.name} ${notificationMessage} ${this.$t('utils.in')} ${notificationDescription}`,
          })
          if(data.status.toLowerCase() !== 'failed') this.onRequest()
        })
        .catch(err => {
          this.$notification.error({
            message: err?.code || 'Ubah Auto Accept Order Gagal',
            description: err?.message,
          })
        })
      }
    },
    async disconnectStore() {
      this.loadingDisconnect = true
      await disconnectBlibli({
        business_id: this.store.business_id,
        data: {
          store_id: this.store.id,
          channel_id: this.store.channel_id,
        },
      })
      .then(({ data }) => {
        if(data?.status?.toLowerCase() === 'success') {
          if(data?.data?.status?.toLowerCase() === 'disconnected') {
            this.successDisconnect = true
            this.disconnectNotification('success')
          } else {
            this.getDisconnectStatus(data?.request_id)
          }
        } else {
          this.disconnectNotification('error')
        }
      })
      .catch(err => {
        console.error(err)
        this.disconnectNotification('error')
      })
    },
    getDisconnectStatus: debounce(async function(request_id) {
      await getBlibliDataDetail({
        business_id: this.store.business_id,
        channel_id: this.store.channel_id,
      })
      .then(({ data: { data: response } }) => {
        if(response?.status === 'DISCONNECTED') {
          this.successDisconnect = true
          this.disconnectNotification('success')
        } else {
          this.hitApi++
          if(this.hitApi > 10) {
            this.disconnectNotification('error')
          } else {
            this.getDisconnectStatus(request_id)
          }
        }
      })
      .catch(err => {
        console.error(err)
        this.disconnectNotification('error')
      })
    }, 1500),
    disconnectNotification(type) {
      const isSuccess = type === 'success'
      const status = isSuccess ? this.$t('store_list_page.auto_accept.status_success') : this.$t('store_list_page.auto_accept.status_failed')
      this.hitApi = 0
      this.loadingDisconnect = false
      this.$notification[type]({
        message: status,
        description: this.$t('store_list_page.auto_accept.deactivate_store_process', { status }),
      })
    },
    showModal(row) {
      this.visible = !this.visible
      this.rowData = row
      this.shop_id = ''
    },
    handleShowModal(type, param, row) {
      switch (type) {
        case 'edit':
          this.showModalEdit = param
          this.rowData = row
          break
        case 'close':
          this.showModalEdit = param
          break
      }
    },
    handleShowModalDisconnectStore(param) {
      this.showModalDisconnectStore = param
      this.dataDisconnectStore = null
    },
    handleSubmitEdit() {
      this.showModalEdit = false
      this.showSuccess = true
    },
    handleShowModalEditWarehouse(param) {
      this.showModalEditWarehouse = param
      this.dataEditWarehouse = null
      if (!param) this.mappingStatusRefreshId += 1
    },
    handleSubmitEditWarehouse(data) {
      this.showModalEditWarehouse = false
    },
    async handleRefreshListAfterMapping(payload) {
      const channelId = payload?.channelId
      const channelCode = payload?.channelCode
      const expectedStatus = payload?.expectedStatus
      if (channelId && channelCode === 'toco_id') {
        const refreshId = ++this.mappingStatusRefreshId
        const rowIndex = this.data.findIndex(item => item.id === channelId)
        try {
          const retryDelays = [500, 1000, 1500, 2000, 2500]
          for (let attempt = 0; attempt <= retryDelays.length; attempt += 1) {
            if (refreshId !== this.mappingStatusRefreshId) return

            const response = await getTocoDetailChannel({
              business_id: this.$route.query.business_id,
              channel_id: channelId,
            })
            const responsePayload = response?.data
            const responseDetailChannel = responsePayload?.data || responsePayload?.response || responsePayload
            const latestStatus = responseDetailChannel?.status?.toUpperCase()
            const responseChannelId = responseDetailChannel?.channel_id || responseDetailChannel?.id
            const isCurrentChannel = String(responseChannelId) === String(channelId)

            if (isCurrentChannel && (!expectedStatus || latestStatus === expectedStatus)) {
              if (rowIndex > -1) {
                this.$set(this.data[rowIndex], 'status', responseDetailChannel.status)
              }
              if (String(this.dataDetailChannel?.channel_id) === String(channelId)) {
                this.dataDetailChannel = responseDetailChannel
              }
              return
            }

            if (attempt < retryDelays.length) {
              await new Promise(resolve => setTimeout(resolve, retryDelays[attempt]))
            }
          }
        } catch (err) {
          console.error('handleRefreshListAfterMapping: failed to fetch toco detail', err)
        }

        if (expectedStatus) {
          this.$notification.warning({
            message: this.$t('store_list_page.mapping_modal.messages.channel_status_not_updated'),
          })
          return
        }
      } else if (channelId && channelCode === 'shopee_id') {
        try {
          const { data: { data: responseDetailChannel } } = await getShopeeDetailChannel({
            business_id: this.$route.query.business_id,
            channel_id: channelId,
          })
          if (responseDetailChannel?.channel_id) {
            const rowIndex = this.data.findIndex(item => item.id === channelId)
            if (rowIndex > -1) {
              this.$set(this.data[rowIndex], 'status', responseDetailChannel.status)
              if (this.dataDetailChannel?.channel_id === channelId) {
                this.dataDetailChannel = responseDetailChannel
              }
            }
            return
          }
        } catch (err) {
          console.error('handleRefreshListAfterMapping: failed to fetch shopee detail', err)
        }
      }
      this.onRequest()
    },
    onRequest() {
      const { page, status, country_id, sales_channel_id, keyword } = this.$route.query
      this.loadingData = true
      this.data = []
      this.defaultPage = +page || 1

      let query = {
        ...this.$route.query,
        page: this.defaultPage,
      }

      if(this.$store.state.user.role_id === '73ed8e78-bb8f-4d90-8547-d5fb54d44b82') {
          query = { ...query, workspace_id: undefined, business_id: undefined }
        }
      this.$store
        .dispatch('channel/GETCHANNEL', {
          ...query,
        })
        .then(async (res) => {
          this.total_row = res.total_row
          this.data = res?.data?.length
            ? await Promise.all(res.data.map(async (channel) => {
              const detail = channel.sales_channel.code === 'blibli_id'
                ? await this.getDetailData(channel.id)
                : {}
              channel.detail = detail
              return channel
            }))
            : []
          this.COUNTRIES = res.country_data
            .filter((v) => {
              return v.id
            })
            .map((v) => {
              return {
                code: v.id,
                name: v.name,
              }
            })
          this.list_status = res.status_data.filter((v) => {
            return v
          })
          this.list_channel = res.sales_channel_data.map((v) => {
            return {
              sales_channel_id: v.id,
              name: v.name,
            }
          })

          this.list_channel.push({
            sales_channel_id: 'all',
          })
          this.COUNTRIES.push({
            code: 'all',
          })
          this.list_status.push('all')

          this.list_channel.unshift(this.list_channel.pop())
          this.list_status.unshift(this.list_status.pop())
          this.COUNTRIES.unshift(this.COUNTRIES.pop())

          this.valueSearch = keyword || ''
          this.valueChannel = Number(sales_channel_id) || 'all'
          this.valueStatus = status || 'all'
          this.valueCountry = Number(country_id) || 'all'
          this.loadingData = false
        })
        .catch((err) => {
          console.error('err: ', err)
          this.loadingData = false
        })
    },
    async getDetailData(channel_id) {
      return await getBlibliDataDetail({
        business_id: this.$route.query.business_id,
        channel_id,
      })
      .then(({ data: { data: response } }) => response || {})
      .catch(() => {})
    },
    onChangeStatus(status) {
      this.valueStatus = status
      if (status === 'all') {
        let temp = {
          ...this.$route.query,
        }
        delete temp.status
        delete temp.page
        this.$router.push({
          query: { ...temp },
        })
      } else {
        this.$router.push({
          query: { ...this.$route.query, status, page: 1 },
        })
      }
    },
    onChangeChannel(sales_channel_id) {
      this.valueChannel = sales_channel_id
      if (sales_channel_id === 'all') {
        let temp = {
          ...this.$route.query,
        }
        delete temp.sales_channel_id
        delete temp.page
        this.$router.push({
          query: { ...temp },
        })
      } else {
        this.$router.push({
          query: { ...this.$route.query, sales_channel_id, page: 1 },
        })
      }
    },
    onChangeCountry(country_id) {
      this.valueCountry = country_id
      if (country_id === 'all') {
        let temp = {
          ...this.$route.query,
        }
        delete temp.country_id
        delete temp.page
        this.$router.push({
          query: { ...temp },
        })
      } else {
        this.$router.push({
          query: { ...this.$route.query, country_id, page: 1 },
        })
      }
    },
    onSearch(val) {
      this.valueSearch = val
      if (val === '') {
        let temp = {
          ...this.$route.query,
        }
        delete temp.keyword
        delete temp.page
        this.$router.push({
          query: { ...temp },
        })
      } else {
        this.$router.push({
          query: { ...this.$route.query, keyword: val, page: 1 },
        })
      }
    },
    onChangeSort(sort_by) {
      this.sortBy = sort_by
      this.$router.push({
        query: { ...this.$route.query, sort_by },
      })
    },
    onChangePage(page) {
      this.defaultPage = page
      this.$router.push({
        query: { ...this.$route.query, page },
      })
    },
    changeQuery(params = {}) {
      this.$router.push({
        query: {
          ...this.$route.query,
          ...params,
        },
      })
    },
    onChangeSearch(e) {
      this.valueSearch = e.target.value
    },
    onSubmitFormAutoAccept() {
      this.$refs.refFormAutoAccept.validate(valid => {
        if (valid) {
          return this.onChangeAutoAccept(this.selectedWarehouseAutoAccept)
        }
      })
    },
    _createNotificationConfig(isSuccess, currentAutoAccept, data = {}, channelName = '') {
      const notificationType = isSuccess ? 'success' : 'error'
      const notificationMessage = isSuccess ? this.$t('store_list_page.auto_accept.status_success') : this.$t('store_list_page.auto_accept.status_failed')
      const notificationDescription = currentAutoAccept ? this.$t('store_list_page.auto_accept.deactivate') : this.$t('store_list_page.auto_accept.activate')
      
      return {
        type: notificationType,
        message: data?.code || `${this.$t('store_list_page.auto_accept.change_auto_accept')} ${notificationMessage}`,
        description: data?.message || 
          `${this.$t('store_list_page.auto_accept_order')} ${channelName} ${notificationMessage} ${this.$t('utils.in')} ${notificationDescription}`,
      }
    },
    _showNotification(config) {
      if (config.type === 'warning') {
        this.$notification.warning({
          message: config.message,
          description: config.description,
        })
      } else {
        this.$notification[config.type]({
          message: config.message,
          description: config.description,
        })
      }
    },
    _resetAutoAcceptState() {
      this.fetchingUpdateAutoAccept = false
      this.showModalAutoAccept = false
      this.formAutoAccept.shipment = undefined
      this.selectedWarehouseAutoAccept = null
      this.isChangeArrangeShipment = false
      this.isChangeAutoAccept = false
    },
    
    _handleApiError(err) {
      console.error(err)
      this._showNotification({
        type: 'error',
        message: err?.code || 'Ubah Auto Accept Order Gagal',
        description: err?.message,
      })
      this._resetAutoAcceptState()
    },
    onChangeAutoAccept(selectedWarehouse) {
      if (!this.dataDrawerDetail?.sales_channel?.code || !this.dataDrawerDetail?.id) {
        return this._showNotification({
          type: 'error',
          message: 'Gagal',
          description: 'Sales Channel Tidak Ditemukan',
        })
      }
      const { sales_channel: { code: channelCode }, id: channelId } = this.dataDrawerDetail
      const { auto_accept: currentAutoAccept } = this.dataDetailChannel
      const channelName = this.dataDrawerDetail?.title || this.dataDrawerDetail?.sales_channel?.name
      if (selectedWarehouse === 'all') {
        this._handleGlobalAutoAccept(channelCode, channelId, currentAutoAccept, channelName)
      } else {
        this._handleWarehouseAutoAccept(selectedWarehouse, channelCode, channelId, currentAutoAccept, channelName)
      }
    },
    _handleGlobalAutoAccept(channelCode, channelId, currentAutoAccept, channelName) {
      if (['tiktok', 'tiktok_id', 'lazada_id'].includes(channelCode)) {
        this.fetchingUpdateAutoAccept = true
        updateAutoAcceptChannel({
          business_id: this.$route.query.business_id,
          channel_code: channelCode,
          channel_id: channelId,
          data: { auto_accept: !currentAutoAccept },
        })
        .then(({ data }) => {
          const isSuccess = data.status.toLowerCase() !== 'failed'
          const config = this._createNotificationConfig(isSuccess, currentAutoAccept, data, channelName)
          this._showNotification(config)
          
          if (isSuccess) {
            this.onShowDrawerDetail(this.dataDrawerDetail)
          }
          this.fetchingUpdateAutoAccept = false
        })
        .catch(this._handleApiError)
      } 
      else if (['shopee_id', 'tokopedia_id', 'toco_id'].includes(channelCode)) {
        this.fetchingUpdateAutoAccept = true
        updateDataDetailChannel({
          business_id: this.$route.query.business_id,
          channel_code: channelCode,
          channel_id: channelId,
          data: { auto_accept: !currentAutoAccept },
        })
        .then(({ data, ...rest }) => {
          const isSuccess = rest.status === 200
          const config = this._createNotificationConfig(isSuccess, currentAutoAccept, data, channelName)
          this._showNotification(config)
          
          if (isSuccess) {
            this.onShowDrawerDetail(this.dataDrawerDetail)
          }
          this.fetchingUpdateAutoAccept = false
        })
        .catch(this._handleApiError)
      } 
      else {
        this._showNotification({
          type: 'warning',
          message: 'Coming Soon',
          description: 'Update auto accept order belum tersedia untuk sales channel ini',
        })
      }
    },
    _handleWarehouseAutoAccept(selectedWarehouse, channelCode, channelId, currentAutoAccept, channelName) {
      let warehouseList = []
      const { shipment } = this.formAutoAccept
      const currentArrangeShipment = shipment || 'PICK_CONFIRMED'
      
      if (['tiktok', 'tiktok_id', 'zalora_id'].includes(channelCode)) {
        warehouseList = this.dataDetailChannel.warehouse_list
      } else if (['blibli_id', 'shopee_id', 'toco_id'].includes(channelCode)) {
        warehouseList = this.warehouseList
      }
      
      if (!(warehouseList?.length > 0)) {
        return this._showNotification({
          type: 'error',
          message: 'Gagal',
          description: 'Warehouse Tidak Ditemukan',
        })
      }
      if (['tiktok', 'tiktok_id'].includes(channelCode)) {
        this._handleTiktokWarehouse(selectedWarehouse, warehouseList, channelCode, channelId, currentAutoAccept, currentArrangeShipment, channelName)
      } else if (['zalora_id'].includes(channelCode)) {
        this._handleZaloraWarehouse(selectedWarehouse, warehouseList, channelCode, channelId, currentAutoAccept, currentArrangeShipment, channelName)
      } else if (['blibli_id'].includes(channelCode)) {
        this._handleBlibliWarehouse(selectedWarehouse, channelId, currentAutoAccept, currentArrangeShipment, channelName)
      } else if (['shopee_id'].includes(channelCode)) {
        this._handleShopeeWarehouse(selectedWarehouse, channelId, currentAutoAccept, currentArrangeShipment, channelName)
      } else if (['toco_id'].includes(channelCode)) {
        this._handleTocoWarehouse(selectedWarehouse, channelId, currentAutoAccept, currentArrangeShipment, channelName)
      } else {
        this._resetAutoAcceptState()
        this._showNotification({
          type: 'warning',
          message: 'Coming Soon',
          description: 'Update auto accept order per-gudang belum tersedia untuk sales channel ini',
        })
      }
    },
    _handleTiktokWarehouse(selectedWarehouse, warehouseList, channelCode, channelId, currentAutoAccept, currentArrangeShipment, channelName) {
      const { warehouse_channel_name, warehouse_master_id } = selectedWarehouse
      const findIndexSelectedWhs = warehouseList.findIndex(
        (whs) => whs.name === warehouse_channel_name && whs.warehouse_id === warehouse_master_id,
      )
      if (findIndexSelectedWhs === -1) {
        return this._showNotification({
          type: 'error',
          message: 'Gagal',
          description: 'Warehouse Tidak Ditemukan',
        })
      }
      const { confirm } = this.formAutoAccept
      warehouseList[findIndexSelectedWhs].auto_accept = confirm
      this.fetchingUpdateAutoAccept = true
      updateTiktokAutoAcceptPerWarehouse({
        business_id: this.$route.query.business_id,
        channel_code: channelCode,
        channel_id: channelId,
        data: {
          ...warehouseList[findIndexSelectedWhs],
          channel_id: channelId,
          channel_order_auto_accept_step: currentArrangeShipment,
        },
      })
      .then(({ data }) => {
        const isSuccess = data.status.toLowerCase() !== 'failed'
        const config = this._createNotificationConfig(isSuccess, currentAutoAccept, data, channelName)
        this._showNotification(config)
        
        if (isSuccess) {
          this.onShowDrawerDetail(this.dataDrawerDetail)
        }
        this._resetAutoAcceptState()
      })
      .catch(this._handleApiError)
    },
    _handleZaloraWarehouse(selectedWarehouse, warehouseList, channelCode, channelId, currentAutoAccept, currentArrangeShipment, channelName) {
      const { warehouse_master_id } = selectedWarehouse
      const findIndexSelectedWhs = warehouseList.findIndex(
        (whs) => whs.warehouse_id === warehouse_master_id,
      )
      if (findIndexSelectedWhs === -1) {
        return this._showNotification({
          type: 'error',
          message: 'Gagal',
          description: 'Warehouse Tidak Ditemukan',
        })
      }
      const { confirm } = this.formAutoAccept
      warehouseList[findIndexSelectedWhs].auto_accept = confirm
      this.fetchingUpdateAutoAccept = true
      const { auto_accept, channel_warehouse_id, name: warehouse_name, warehouse_pickup_config } = warehouseList[findIndexSelectedWhs]
      
      updateZaloraAutoAcceptPerWarehouse({
        business_id: this.$route.query.business_id,
        channel_code: channelCode,
        channel_id: channelId,
        data: {
          channel_id: channelId,
          auto_accept,
          channel_warehouse_id,
          warehouse_name,
          ...warehouse_pickup_config,
          channel_order_auto_accept_step: currentArrangeShipment,
        },
      })
      .then(({ data }) => {
        const isSuccess = data.status.toLowerCase() !== 'failed'
        const config = this._createNotificationConfig(isSuccess, currentAutoAccept, data, channelName)
        this._showNotification(config)
        
        if (isSuccess) {
          this.onShowDrawerDetail(this.dataDrawerDetail)
        }
        this._resetAutoAcceptState()
      })
      .catch(this._handleApiError)
    },
    _handleTocoWarehouse(selectedWarehouse, channelId, currentAutoAccept, currentArrangeShipment, channelName) {
      const { channel_warehouse_id, warehouse_channel_name: name, detail_address } = selectedWarehouse
      const { confirm } = this.formAutoAccept
      this.fetchingUpdateAutoAccept = true
      updateTocoAutoAcceptPerWarehouse({
        business_id: this.$route.query.business_id,
        channel_id: channelId,
        data: {
          channel_warehouse_id,
          name,
          detail_address: detail_address || '',
          status: 'ACTIVE',
          is_default: selectedWarehouse.is_default || false,
          auto_accept: confirm,
          channel_order_auto_accept_step: currentArrangeShipment,
          time_zone: 'Asia/Jakarta',
          shipping_document_type: selectedWarehouse.shipping_document_type || 'THERMAL',
          shipping_document_size: selectedWarehouse.shipping_document_size || 'A6',
        },
      })
      .then(({ data }) => {
        const isSuccess = data.status?.toLowerCase() !== 'failed'
        const config = this._createNotificationConfig(isSuccess, currentAutoAccept, data, channelName)
        this._showNotification(config)
        
        if (isSuccess) {
          this.onShowDrawerDetail(this.dataDrawerDetail)
        }
        this._resetAutoAcceptState()
      })
      .catch(this._handleApiError)
    },
    _handleShopeeWarehouse(selectedWarehouse, channelId, currentAutoAccept, currentArrangeShipment, channelName) {
      const { channel_warehouse_id, warehouse_channel_name: name, detail_address } = selectedWarehouse
      const { confirm } = this.formAutoAccept
      this.fetchingUpdateAutoAccept = true
      updateShopeeAutoAcceptPerWarehouse({
        business_id: this.$route.query.business_id,
        channel_id: channelId,
        data: {
          channel_warehouse_id,
          name,
          detail_address: detail_address || '',
          status: 'ACTIVE',
          is_default: selectedWarehouse.is_default || false,
          auto_accept: confirm,
          channel_order_auto_accept_step: currentArrangeShipment,
          time_zone: 'Asia/Jakarta',
          shipping_document_type: selectedWarehouse.shipping_document_type || 'THERMAL',
          shipping_document_size: selectedWarehouse.shipping_document_size || 'A6',
        },
      })
      .then(({ data }) => {
        const isSuccess = data.status?.toLowerCase() !== 'failed'
        const config = this._createNotificationConfig(isSuccess, currentAutoAccept, data, channelName)
        this._showNotification(config)
        
        if (isSuccess) {
          this.onShowDrawerDetail(this.dataDrawerDetail)
        }
        this._resetAutoAcceptState()
      })
      .catch(this._handleApiError)
    },
    _handleBlibliWarehouse(selectedWarehouse, channelId, currentAutoAccept, currentArrangeShipment, channelName) {
      const { warehouse_channel_id } = selectedWarehouse
      const { confirm } = this.formAutoAccept
      this.fetchingUpdateAutoAccept = true
      updateAutoAcceptPerWarehouseBlibliChannel({
        business_id: this.$route.query.business_id,
        data: {
          channel_id: channelId,
          pickup_point_id: warehouse_channel_id,
          warehouse_config: {
            auto_accept: confirm,
            time_zone: "Asia/Jakarta",
            channel_order_auto_accept_step: currentArrangeShipment,
          },
        },
      })
      .then(({ data }) => {
        const isSuccess = data.status.toLowerCase() === 'ok'
        const config = this._createNotificationConfig(isSuccess, currentAutoAccept, data, channelName)
        
        this.$notification.destroy()
        this._showNotification(config)
        
        if (isSuccess) {
          this.onShowDrawerDetail(this.dataDrawerDetail)
        }
        this._resetAutoAcceptState()
      })
      .catch(this._handleApiError)
    },
    async onShowDrawerDetail(item) {
      this.viewDetail = true
      this.dataDrawerDetail = item
      this.warehouseList = []
      
      if(['tokopedia_id'].includes(item.sales_channel.code)) {
        this.loadingWarehouse = true
        await Promise.all([
          this._fetchAllWarehouses({
            ...this.$route.query,
            channel_code: item.sales_channel.code,
          }),
          item.status === 'CONNECTED' ? getTokopediaDetailChannel({
            business_id: this.$route.query.business_id,
            channel_id: item.id,
          }) : Promise.resolve(),
        ])
          .then(([responseMaster, { data: { data: responseDetailChannel } }]) => {
            const responseWarehouseChannel = responseDetailChannel?.warehouses
            responseWarehouseChannel?.forEach(res => {
              const findMasterWarehouse = responseMaster.find(master => master.id === res.warehouse_id)
              if(findMasterWarehouse?.name && res.warehouse_id) {
                this.warehouseList.push({
                  auto_accept: res.auto_accept,
                  warehouse_master_id: res.warehouse_id,
                  warehouse_master_name: findMasterWarehouse.name,
                  warehouse_channel_name: res.channel_warehouse_name,
                })
              }
            })
            if (responseDetailChannel?.channel_id) {
              this.dataDetailChannel = responseDetailChannel
            } else {
              this.dataDetailChannel = {}
            }
          })
          .catch(err => {
            this.warehouseList = []
            this.dataDetailChannel = {}
            console.error(err)
          })
          .finally(() => this.loadingWarehouse = false)
      } else if(['toco_id'].includes(item.sales_channel.code)) {
        this.loadingWarehouse = true
        await Promise.all([
          this._fetchAllWarehouses({
            ...this.$route.query,
            channel_code: item.sales_channel.code,
          }),
          item.status === 'CONNECTED' ? getTocoDetailChannel({
            business_id: this.$route.query.business_id,
            channel_id: item.id,
          }) : Promise.resolve(),
        ])
          .then(([responseMaster, { data: { data: responseDetailChannel } }]) => {
            const responseWarehouseChannel = responseDetailChannel?.warehouses
            responseWarehouseChannel?.forEach(res => {
              const findMasterWarehouse = responseMaster.find(master => master.id === res.warehouse_id)
              if(findMasterWarehouse?.name && res.warehouse_id) {
                let channelOrderAutoAcceptStep = '-'
                if (!!res.auto_accept) {
                  channelOrderAutoAcceptStep = this.shipmentList.find(item => item.value === res.channel_order_auto_accept_step)?.label || channelOrderAutoAcceptStep
                }
                this.warehouseList.push({
                  auto_accept: res.auto_accept,
                  warehouse_master_id: res.warehouse_id,
                  warehouse_master_name: findMasterWarehouse.name,
                  warehouse_channel_name: res.channel_warehouse_name,
                  channel_order_auto_accept_step: channelOrderAutoAcceptStep,
                  channel_warehouse_id: res.channel_warehouse_id,
                  detail_address: res.detail_address || '',
                  is_default: res.is_default || false,
                  shipping_document_type: res.shipping_document_type || 'THERMAL',
                  shipping_document_size: res.shipping_document_size || 'A6',
                })
              }
            })
            if (responseDetailChannel?.channel_id) {
              this.dataDetailChannel = responseDetailChannel
            } else {
              this.dataDetailChannel = {}
            }
          })
          .catch(err => {
            this.warehouseList = []
            this.dataDetailChannel = {}
            console.error(err)
          })
          .finally(() => this.loadingWarehouse = false)
      } else if(['shopee_id'].includes(item.sales_channel.code)) {
        this.loadingWarehouse = true
        await Promise.all([
          this._fetchAllWarehouses({
            ...this.$route.query,
            channel_code: item.sales_channel.code,
          }),
          item.status === 'CONNECTED' ? getShopeeDetailChannel({
            business_id: this.$route.query.business_id,
            channel_id: item.id,
          }) : Promise.resolve(),
        ])
          .then(([responseMaster, { data: { data: responseDetailChannel } }]) => {
            const responseWarehouseChannel = responseDetailChannel?.warehouses
            responseWarehouseChannel?.forEach(res => {
              const findMasterWarehouse = responseMaster.find(master => master.id === res.warehouse_id)
              if(findMasterWarehouse?.name && res.warehouse_id) {
                let channelOrderAutoAcceptStep = '-'
                if (!!res.auto_accept) {
                  channelOrderAutoAcceptStep = this.shipmentList.find(item => item.value === res.channel_order_auto_accept_step)?.label || channelOrderAutoAcceptStep
                }
                this.warehouseList.push({
                  auto_accept: res.auto_accept,
                  warehouse_master_id: res.warehouse_id,
                  warehouse_master_name: findMasterWarehouse.name,
                  warehouse_channel_name: res.channel_warehouse_name,
                  channel_order_auto_accept_step: channelOrderAutoAcceptStep,
                  channel_warehouse_id: res.channel_warehouse_id,
                  detail_address: res.detail_address || '',
                  is_default: res.is_default || false,
                  shipping_document_type: res.shipping_document_type || 'THERMAL',
                  shipping_document_size: res.shipping_document_size || 'A6',
                })
              }
            })
            if (responseDetailChannel?.channel_id) {
              this.dataDetailChannel = responseDetailChannel
            } else {
              this.dataDetailChannel = {}
            }
          })
          .catch(err => {
            this.warehouseList = []
            this.dataDetailChannel = {}
            console.error(err)
          })
          .finally(() => this.loadingWarehouse = false)
      } else if(['tiktok', 'tiktok_id'].includes(item.sales_channel.code)) {
        this.loadingWarehouse = true
        this.abortController = new AbortController();
        await Promise.all([
          this._fetchAllWarehouses({
            ...this.$route.query,
            channel_code: item.sales_channel.code,
          }),
          item.status === 'CONNECTED' ? getTiktokDetailChannel({
            business_id: this.$route.query.business_id,
            channel_id: item.id,
            signal: this.abortController.signal,
          }) : Promise.resolve(),
        ])
        .then(([responseMaster, responseDetail = {}]) => {
          if (this.abortController?.signal.aborted) {
            return;
          }
          const responseDetailChannel = responseDetail?.data?.data || {};
          const responseWarehouseChannel = responseDetailChannel?.warehouse_list || [];
          
          responseWarehouseChannel.forEach(res => {
            const findMasterWarehouse = responseMaster.find(master => master.id === res.warehouse_id);
            if(findMasterWarehouse?.name && res.warehouse_id) {
              let channelOrderAutoAcceptStep = '-'
              if (!!res.auto_accept) {
                channelOrderAutoAcceptStep = this.shipmentList.find(item => item.value === res.channel_order_auto_accept_step)?.label || channelOrderAutoAcceptStep
              }
              this.warehouseList.push({
                auto_accept: res.auto_accept,
                warehouse_master_id: res.warehouse_id,
                warehouse_master_name: findMasterWarehouse.name,
                warehouse_channel_name: res.name,
                channel_order_auto_accept_step: channelOrderAutoAcceptStep,
              });
            }
          });
          
          this.dataDetailChannel = responseDetailChannel?.shop_id ? responseDetailChannel : {};
        })
        .catch(err => {
          if (err.name === 'AbortError') {
            return;
          }
          this.warehouseList = [];
          this.dataDetailChannel = {};
          console.error(err);
        })
        .finally(() => {
          if (!this.abortController?.signal.aborted) {
            this.loadingWarehouse = false
          }
        });
      } else if(['lazada_id'].includes(item.sales_channel.code)) {
        this.loadingWarehouse = true
        await Promise.all([
          this._fetchAllWarehouses({
            ...this.$route.query,
            channel_code: item.sales_channel.code,
          }),
          item.status === 'CONNECTED' ? getDetailChannel({
            business_id: this.$route.query.business_id,
            channel_code: item.sales_channel.code,
            channel_id: item.id,
          }) : Promise.resolve(),
        ])
          .then(([responseMaster, { data: { data: responseDetailChannel } }]) => {
            const responseWarehouseChannel = responseDetailChannel?.warehouses
            responseWarehouseChannel?.forEach(res => {
              const findMasterWarehouse = responseMaster.find(master => master.id === res.warehouse_id)
              if(findMasterWarehouse?.name && res.warehouse_id) {
                this.warehouseList.push({
                  auto_accept: res.auto_accept,
                  warehouse_master_id: res.warehouse_id,
                  warehouse_master_name: findMasterWarehouse.name,
                  warehouse_channel_name: res.channel_warehouse_name,
                })
              }
            })
            if (responseDetailChannel?.channel_id) {
              this.dataDetailChannel = responseDetailChannel
            } else {
              this.dataDetailChannel = {}
            }
          })
          .catch(err => {
            this.warehouseList = []
            this.dataDetailChannel = {}
            console.error(err)
          })
          .finally(() => this.loadingWarehouse = false)
      } else if(['blibli_id'].includes(item.sales_channel.code)) {
        this.loadingWarehouse = true
        await Promise.all([
          this._fetchAllWarehouses({
            ...this.$route.query,
            channel_code: item.sales_channel.code,
          }),
          getBlibliPickupPoint({
            business_id: this.$route.query.business_id,
            channel_id: item.id,
          }),
        ])
          .then(([responseMaster, { data: { data: responseChannel } }]) => {
            responseChannel?.forEach(res => {
              const findMasterWarehouse = responseMaster.find(master => master.id === res.master_warehouse_id)
              if(findMasterWarehouse?.name && res.warehouse_map_state === 'MAPPED') {
                let channelOrderAutoAcceptStep = '-'
                if (!!res.auto_accept) {
                  channelOrderAutoAcceptStep = this.shipmentList.find(item => item.value === res.channel_order_auto_accept_step)?.label || channelOrderAutoAcceptStep
                }
                this.warehouseList.push({
                  auto_accept: res.auto_accept,
                  warehouse_master_id: res.master_warehouse_id,
                  warehouse_master_name: findMasterWarehouse.name,
                  warehouse_channel_name: res.display_name,
                  warehouse_channel_id: res.id,
                  channel_order_auto_accept_step: channelOrderAutoAcceptStep,
                })
              }
            })
          })
          .catch(err => {
            this.warehouseList = []
            console.error(err)
          })
          .finally(() => this.loadingWarehouse = false)
      } else if(['zalora_id'].includes(item.sales_channel.code)) {
        this.loadingWarehouse = true
        this.abortController = new AbortController();
        await Promise.all([
          this._fetchAllWarehouses({
            ...this.$route.query,
            channel_code: item.sales_channel.code,
          }),
          item.status === 'CONNECTED' ? getZaloraDetailChannel({
            business_id: this.$route.query.business_id,
            channel_id: item.id,
            signal: this.abortController.signal,
          }) : Promise.resolve(),
        ])
        .then(([responseMaster, responseDetail = {}]) => {
          if (this.abortController?.signal.aborted) {
            return;
          }
          const responseDetailChannel = responseDetail?.data?.data || {};
          const responseWarehouseChannel = responseDetailChannel?.warehouse_list || [];
          
          responseWarehouseChannel.forEach(res => {
            const findMasterWarehouse = responseMaster.find(master => master.id === res.warehouse_id);
            if(findMasterWarehouse?.name && res.warehouse_id) {
              let channelOrderAutoAcceptStep = '-'
              if (!!res.auto_accept) {
                channelOrderAutoAcceptStep = this.shipmentList.find(item => item.value === res.channel_order_auto_accept_step)?.label || channelOrderAutoAcceptStep
              }
              this.warehouseList.push({
                auto_accept: res.auto_accept,
                warehouse_master_id: res.warehouse_id,
                warehouse_master_name: findMasterWarehouse.name,
                warehouse_channel_name: res.name || 'Default Warehouse',
                channel_order_auto_accept_step: channelOrderAutoAcceptStep,
              });
            }
          });
          
          this.dataDetailChannel = responseDetailChannel?.shop_id ? responseDetailChannel : {};
        })
        .catch(err => {
          if (err.name === 'AbortError') {
            return;
          }
          this.warehouseList = [];
          this.dataDetailChannel = {};
          console.error(err);
        })
        .finally(() => {
          if (!this.abortController?.signal.aborted) {
            this.loadingWarehouse = false
          }
        });
      } else if(['distributor'].includes(item.sales_channel.code)) {
        this.loadingWarehouse = true
        this.abortController = new AbortController();
        await Promise.all([
          this._fetchAllWarehouses({
            ...this.$route.query,
            channel_code: item.sales_channel.code,
          }),
          item.status === 'CONNECTED' ? (async () => {
            const allWarehouses = []
            let page = 1
            let isLast = false
            while (!isLast) {
              if (this.abortController?.signal.aborted) return { data: { content: allWarehouses } }
              const { data: warehouseRes } = await getDistributorAppWarehouses({ page }, item.id)
              const content = warehouseRes?.content || []
              allWarehouses.push(...content)
              isLast = warehouseRes?.last === true || content.length === 0
              page += 1
            }
            return { data: { content: allWarehouses } }
          })() : Promise.resolve(),
        ])
        .then(([responseMaster, responseDetail = {}]) => {
          if (this.abortController?.signal.aborted) {
            return;
          }
          const responseWarehouseChannel = responseDetail?.data?.content || [];
          
          responseWarehouseChannel.forEach(res => {
            const findMasterWarehouse = responseMaster.find(master => master.id === res.master_warehouse_id);
            if(findMasterWarehouse?.name && res.master_warehouse_id) {
              this.warehouseList.push({
                warehouse_master_id: res.master_warehouse_id,
                warehouse_master_name: findMasterWarehouse.name,
                warehouse_channel_name: res.name || '-',
              });
            }
          });
          
          this.dataDetailChannel = {};
        })
        .catch(err => {
          if (err.name === 'AbortError') {
            return;
          }
          this.warehouseList = [];
          this.dataDetailChannel = {};
          console.error(err);
        })
        .finally(() => {
          if (!this.abortController?.signal.aborted) {
            this.loadingWarehouse = false
          }
        });
      }
    },
    openModalApprove(data) {
      this.modalApproveConfirmation = !this.modalApproveConfirmation
      this.selectedData = data
    },
    actionModalApproveConfirmation(id) {
      this.modalApproveConfirmation = !this.modalApproveConfirmation
      this.selectedData = id
    },
    onSuccessApprove() {
      this.modalApproveConfirmation = false
      this.selectedData = null
      this.$router.go()
    },
    openModalAddWarehouse(data) {
      if (['tiktok', 'tiktok_id', 'shopee_id', 'blibli_id', 'toco_id'].includes(data.sales_channel.code)) {
        this.dataEditWarehouse = data
        this.showModalEditWarehouse = true
      } else {
        this.showModalAddWarehouseChannel = !this.showModalAddWarehouseChannel
        this.selectedData = data
      }
    },
    actionModalAddWarehouseChannel(id) {
      this.showModalAddWarehouseChannel = !this.showModalAddWarehouseChannel
      this.selectedData = id
    },
    onSuccessAddWarehouse() {
      this.showModalAddWarehouseChannel = false
      this.selectedData = null
      this.$router.go()
    },
    refreshPage() {
      window.location.reload()
    },
    onPopconfirmDisconnectStore(channelCode, channelId) {
      this.dataDisconnectStore = {
        channelCode,
        channelId,
      }
      this.showModalDisconnectStore = true
    },
    async onDisconnectChannel({ channelCode, channelId }) {
      this.loadingModalDisconnectStore = true;
      try {
        if (['tokopedia_id', 'lazada_id'].includes(channelCode)) {
          await this.handleStandardDisconnect(channelCode, channelId);
        } else if (['shopee', 'shopee_id'].includes(channelCode)) {
          await this.handleShopeeDisconnect(channelId);
        } else if (['toco', 'toco_id'].includes(channelCode)) {
          await this.handleTocoDisconnect(channelId);
        } else if (['tiktok', 'tiktok_id'].includes(channelCode)) {
          await this.handleTiktokDisconnect(channelId);
        } else if (['zalora_id'].includes(channelCode)) {
          await this.handleZaloraDisconnect(channelId)
        } else {
          this.showErrorNotification("Store channel belum dapat diputuskan/disconnect");
        }
        await this.refreshPage();
      } catch (error) {
        this.showErrorNotification(
          error.message || "Store channel belum dapat diputuskan/disconnect",
        );
        console.error(error);
      } finally {
        this.handleShowModalDisconnectStore(false);
        this.loadingModalDisconnectStore = false;
      }
    },
    async handleStandardDisconnect(channelCode, channelId) {
      await disconnectChannelWithPause({
        business_id: this.$route.query.business_id,
        channel_id: channelId,
        channel_code: channelCode,
      });
    },
    async handleTocoDisconnect(channelId) {
      await disconnectTocoIntegration({
        business_id: this.$route.query.business_id,
        channel_id: channelId,
      });
    },
    async handleShopeeDisconnect(channelId) {
      await disconnectShopeeIntegration({
        business_id: this.$route.query.business_id,
        channel_id: channelId,
      });
    },
    async handleTiktokDisconnect(channelId) {
      const { data: { data: responseDetailChannel } } = await getTiktokDetailChannel({
        business_id: this.$route.query.business_id,
        channel_id: channelId,
      });
      if (!responseDetailChannel?.shop_id) {
        throw new Error("Shop ID belum tersedia");
      }
      await disconnectTiktokIntegration({
        business_id: this.$route.query.business_id,
        channel_id: channelId,
        shop_id: responseDetailChannel.shop_id,
      });
    },
    async handleZaloraDisconnect(channelId) {
      await disconnectZalora({
        access_key: '1234567890',
        business_id: this.$route.query.business_id,
        channel_id: channelId,
      })
    },
    showErrorNotification(description, message = "Terjadi kesalahan") {
      this.$notification.error({ message, description });
    },
    async onReconnectChannel(channelCode, channelId) {
      if (['shopee_id', 'tokopedia_id', 'toco_id'].includes(channelCode)) {
        const res = await reconnectChannelWithPause({
          business_id: this.$route.query.business_id,
          channel_id: channelId,
          channel_code: channelCode,
        })
        return this.refreshPage()
      } else if (['tiktok', 'tiktok_id'].includes(channelCode)) {
        return this.$router.push({
          path: '/add-store',
          query: {
            ...this.$route.query,
            default_channel_code: 'tiktok,tiktok_id',
          },
        })
      }
      this.$notification.error({
        message: "Terjadi kesalahan",
        description: "Store channel belum dapat disambungkan/reconnect",
      })
    },
    onReauthorizeShopee(val) {
      const salesChannel = {
        id: val.sales_channel.id,
        code: val.sales_channel.code,
      }
      let url = new URL(window.location.origin)
      this.$store.dispatch('integration/SYNCSHOPEE', {
        sales_channel: salesChannel,
        redirect_url: `${url}reauthorize/shopee`,
        business: this.$route.query.business_id,
      })
      .then(({ data }) => {
        if (data?.data?.authorization_url && data?.data?.client_id) {
          const route = {
            path: this.$route.path,
            query: {
              ...this.$route.query,
              is_reauthorize: true,
              client_id: data?.data?.client_id,
              channel_id: val.id,
              name: 'shopee',
            },
          }
          localStorage.setItem('pathCallback', JSON.stringify(route))
          window.location = data?.data?.authorization_url
        } else {
          this.$notification.error({
            message: 'Reauthorize Failed',
            description: 'Failed to get authorization url from Shopee.',
          })
        }
      })
      .catch((err) => {
        this.$notification.error({
          message: 'Reauthorize Failed',
          description: err.response?.data?.message || err.message,
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-search:not(:hover) {
  background-color: #2196f3;
  color: #fff;
}

.st-connect::before,
.st-pending::before,
.st-disconnected::before,
.st-reauth::before {
  content: '';
  display: inline-block;
  margin-right: 0.5rem;
  vertical-align: middle;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #ff477e;
  user-select: none;
}
.menu-disconnect {
  color: #f5222d;
}
.st-connect::before {
  background: #52c41a;
}

.st-pending::before {
  background: #faad14;
}

.st-disconnected::before {
  background: #f5222d;
}

@keyframes dotPulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(24, 144, 255, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 6px rgba(24, 144, 255, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(24, 144, 255, 0);
  }
}

.st-reauth::before {
  background: #1890ff;
  animation: dotPulse 1.5s infinite;
}

.btn-edit:not(:hover) {
  background: #e3f2fd !important;
  border-color: #e3f2fd !important;
  color: #2196f3 !important;
}
.btn-del:not(:hover) {
  background: #ffebf1 !important;
  border-color: #ffebf1 !important;
  color: #ff477e !important;
}
.btn-url:not(:hover) {
  background: #ebfefe !important;
  border-color: #ebfefe !important;
  color: #07beb8 !important;
}

.add__button {
  color: #fff !important;
  background: #ff0854 !important;
}
.store-name {
  color: var(--kit-color-primary);
  cursor: pointer;
}
.drawer-container {
  gap: 10px 0px;

}
.action-btn {
  width: fit-content;
  button {
    margin: 3px;
  }
}
</style>

<style lang="scss">
.select-antd-default.ant-select-lg .ant-select-selection__rendered {
  line-height: 38px !important;
}
.warning {
  &-logo {
    margin-bottom: 20px;
    text-align: center;

    i {
      font-size: 96px;
    }
  }

  &-description {
    margin-bottom: 30px;
    text-align: center;
    font-size: 16px;
  }

  &-loading {
    margin-bottom: 30px;

    .ant-skeleton-title {
      width: 100% !important;
    }
  }
}
.whs .ant-skeleton-title {
  margin: 0 !important;
}
.binding-box {
  position: relative;
  width: 100%;
  margin-top: 2rem;
  padding: 10px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;

  &-image {
    position: absolute;
    width: 150px;
    padding: 5px;
    top: -18px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 30px;

    & > div {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
    }

    img {
      height: 24px;
      width: auto;
    }
  }

  &-checkbox {
    display: flex !important;
    align-items: flex-start;

    > span {
      margin-top: -5px;
      font-size: 12px;

      &.ant-checkbox {
        margin-top: 0;
      }
    }
  }

  h3 {
    margin: 1.25rem 0 1rem;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }

  ol {
    padding-left: 15px;
  }

  li {
    padding-left: 12px;
    font-size: 12px;
  }
}

.store-table-wrapper {
  max-height: calc(100vh - 330px);
  overflow-y: auto;
}
</style>
